import { Container, IconTile, SectionHeading } from "./primitives";

const FEATURES = [
  { icon: "lucide:chart-no-axes-column", title: "Health Insights Dashboard",   body: "Trends, vitals, and key metrics visualized clearly, not buried in pages of raw clinical text." },
  { icon: "lucide:monitor-dot",          title: "Medications & Prescriptions", body: "All active prescriptions, dosages, refill dates, and interaction flags in one organized view." },
  { icon: "lucide:fullscreen",           title: "Diagnoses & Imaging",         body: "ICD codes decoded into plain language, with imaging reports and radiology notes attached." },
  { icon: "lucide:dollar-sign",          title: "Health Timeline",             body: "A chronological view of your full medical history: hospitalizations, tests, diagnoses, procedures." },
  { icon: "lucide:bell",                 title: "Real-Time Notifications",     body: "Alerts when new records arrive, or lab values fall outside the normal range." },
  { icon: "lucide:message-circle-question", title: "Ask About Your Records", body: "Ask questions about your health records in plain language and get answers drawn from your own data." },
];

export function FeaturesSection() {
  return (
    <section id="features" className="scroll-mt-[68px] bg-white pt-[88px] pb-20 lg:pt-[110px] lg:pb-[100px]">
      <Container>
        <SectionHeading eyebrow="Core features" title="Everything your health records should be" />

        <div className="mt-14 grid gap-x-[22px] gap-y-5 md:grid-cols-2 lg:grid-cols-3">
          {FEATURES.map(f => (
            <article key={f.title} className="min-h-[199px] rounded-2xl border border-[#E8E9EE] bg-white px-7 pt-7 pb-6">
              <IconTile
                icon={f.icon}
                className="h-11 w-11 rounded-[10px] bg-[#FDEBEE]"
                iconClassName="h-[18px] w-[18px] text-[#F18095]"
              />
              <h3 className="!mt-[22px] text-[17px] font-bold leading-6 tracking-[-0.015em] text-[#120240]">{f.title}</h3>
              <p className="!mt-2 text-[14.3px] leading-6 text-[#4B5563]">{f.body}</p>
            </article>
          ))}
        </div>
      </Container>
    </section>
  );
}
